"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flipCamera = void 0;
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
function flipCamera(cameraSubject) {
    switch (cameraSubject) {
        case streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD:
            return streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_PERSON;
        case streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_PERSON:
            return streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD;
        default:
            return streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD;
    }
}
exports.flipCamera = flipCamera;
//# sourceMappingURL=flip_camera.js.map